angular.module('impactx.saperrormessage').controller('SAPPRSErrorListController', SAPPRSErrorListController);
SAPPRSErrorListController.$inject = [
    'dataGen',
    'selectedListItems',
    '$mdToast',
    'ListHelperService',
    '$scope',
    'TranslationService'
];

function SAPPRSErrorListController(dataGen, selectedListItems, $mdToast, ListHelperService, $scope, TranslationService) {
    var buttonDefinition = [
        {
            label: "accept",
            action: accept,
            condition: canAccept,
            process: 'SAPErrorRequest'
        },
        {
            label: "deny",
            action: deny,
            condition: canDeny,
            process: 'SAPErrorRequest'
        },
        {
            label: "reexport",
            action: reExport,
            condition: canReExport,
            process: 'SAPErrorRequest'
        },
        {
            label: "delete",
            action: deleteErrorMessage,
            condition: canDeleteError,
            process: 'DeleteExportStatusError'
        },
        {
            label: "delete",
            action: deleteErrorMessage,
            condition: canDeleteAll,
            process: 'DeleteExportStatusAll'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/saperrormessage/templates/saperrorlist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/saperrormessage/listprs',
        ctrl: this,
        id: "sapprserrorlist",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    var refresh = function () {
        ListHelperService.refreshListData($scope, 'sapPRSErrorListController', {unselectRow: selectedListItems.getFirstSelectedItem()});
    };

    function accept() {
        var paramObj = {
            objId: selectedListItems.getFirstSelectedItem().objId,
            method: selectedListItems.getFirstSelectedItem().method
        };
        dataGen.postAsForm({}, paramObj, '/saperrormessage/accept').then(function (result) {
            if (result.errors.length === 0) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(result.trns.acceptSuccess)
                        .position("bottom right")
                        .hideDelay(10000)
                );
                refresh();
            }
        });
    }

    function deny() {
        var paramObj = {
            objId: selectedListItems.getFirstSelectedItem().objId,
            method: selectedListItems.getFirstSelectedItem().method
        };
        dataGen.postAsForm({}, paramObj, '/saperrormessage/deny').then(function (result) {
            if (result.errors.length === 0) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(result.trns.denySuccess)
                        .position("bottom right")
                        .hideDelay(10000)
                );
                refresh();
            }
        });
    }

    function reExport() {
        var paramObj = {
            objId: selectedListItems.getFirstSelectedItem().objId,
            method: selectedListItems.getFirstSelectedItem().method
        };
        dataGen.postAsForm({}, paramObj, '/saperrormessage/reexport').then(function (result) {
            if (result.errors.length === 0) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(result.trns.reexportSuccess)
                        .position("bottom right")
                        .hideDelay(10000)
                );
                refresh();
            }
        });
    }

    function deleteErrorMessage() {
        var paramObj = {
            objId: selectedListItems.getFirstSelectedItem().objId,
            method: selectedListItems.getFirstSelectedItem().method,
            status: selectedListItems.getFirstSelectedItem().statusId
        };
        dataGen.postAsForm({}, paramObj, '/saperrormessage/delete').then(function (result) {
            if (result.errors.length === 0) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(TranslationService.get('deleteSuccess'))
                        .position("bottom right")
                        .hideDelay(10000)
                );
                refresh();
            }
        });
    }

    function canAccept() {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection() && selectedItem.actions.showAccept && !selectedItem.deleted;
    }

    function canDeny() {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection() && selectedItem.actions.showDeny && !selectedItem.deleted;
    }

    function canReExport() {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection() && selectedItem.actions.showReexport && !selectedItem.deleted;
    }

    function canDeleteError() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().statusId == 30;
    }

    function canDeleteAll() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().statusId != 30;
    }
}